'use strict';

exports.__esModule = true;
exports['default'] = getThreshold;

function getThreshold(thresholds) {
  /* eslint-disable no-empty */
  var width = getWindowWidth();
  var b = thresholds.length;
  while (--b && width < thresholds[b]) {}
  return b;
}

// using documentElement because
// clientWidth doesnt subtract the scroll bar
function getWindowWidth() {
  if (typeof window === 'undefined') return Infinity;
  return document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-cellblock/lib/util/getThreshold.js
// module id = 762
// module chunks = 0